<!-- src/app/dashboard-admin/dashboard-admin.component.html -->
<div class="dashboard-container">

  <!-- ══════════════ DASHBOARD HEADER ══════════════ -->
  <!-- <div class="dashboard-header">
    <div class="header-left">
      <p class="dashboard-subtitle">Overview of onboarding, profile completion and engagement analytics</p>
    </div>
    <div class="header-right">
      <div class="date-range-selector">
        <i class="bi bi-calendar3"></i>
        <select [(ngModel)]="selectedDateRange" class="date-select">
          <option value="last7">Last 7 Days</option>
          <option value="last30">Last 30 Days</option>
          <option value="last90">Last 90 Days</option>
          <option value="thisYear">This Year</option>
        </select>
        <i class="bi bi-chevron-down select-arrow"></i>
      </div>
    </div>
  </div> -->

  <!-- ══════════════ SUMMARY METRICS ROW ══════════════ -->
  <div class="summary-row">
    <div class="summary-card"
         *ngFor="let metric of summaryMetrics; let i = index"
         [style.cursor]="i === 0 || i === 1 || i === 2 ? 'pointer' : 'default'"
         (click)="i === 0 ? navigateToSummaryOnboardingUsers() : i === 1 ? navigateToLoginUsers() : i === 2 ? navigateToSummaryMobileUsers() : null">
      <div class="summary-icon-wrap">
        <i class="bi {{ metric.icon }}"></i>
      </div>
      <div class="summary-info">
        <span class="summary-label">{{ metric.label }}</span>
        <span class="summary-value">{{ metric.value }}</span>
      </div>
      <div class="summary-trend" [ngClass]="getTrendClass(metric.trend)">
        <i class="bi {{ getTrendIcon(metric.trend) }}"></i>
        <span>{{ formatTrend(metric.trend) }}</span>
        <span class="trend-period">{{ metric.trendLabel }}</span>
      </div>
    </div>
  </div>

  <!-- ══════════════ ANALYTICS CARDS ROW ══════════════ -->
  <div class="analytics-row">

    <!-- ─── Card 1: Onboarding Trend ─── -->
    <div class="analytics-card">
      <div class="card-header">
        <div class="card-title-group">
          <span class="card-badge">
            <i class="bi bi-people-fill"></i>
          </span>
          <span class="card-title">Onboarding Trend</span>
        </div>
        <!--
          Segmented Daily/Weekly/Monthly/Quarterly buttons replaced with a single
          dropdown (Today / Yesterday / Last 7 Days). Quarterly is intentionally
          hidden for now — its logic still lives in the component (see
          getOnboardingDateRangeParams / computePeriodLabel) but is not exposed
          in onboardingFilterOptions, so it's disabled rather than deleted.
        -->
        <div class="onboarding-filter-select-wrap"
             [class.onboarding-filter-select-wrap--open]="onboardingFilterMenuOpen"
             (click)="$event.stopPropagation()">
          <button type="button"
                  class="onboarding-filter-select-btn"
                  (click)="toggleOnboardingFilterMenu()"
                  [attr.aria-expanded]="onboardingFilterMenuOpen"
                  aria-haspopup="listbox">
            <i class="bi bi-calendar-week onboarding-filter-select-icon"></i>
            <span class="onboarding-filter-select-label">{{ getOnboardingFilterLabel() }}</span>
            <i class="bi bi-chevron-down onboarding-filter-select-arrow"></i>
          </button>

          <div class="onboarding-filter-menu" role="listbox" *ngIf="onboardingFilterMenuOpen">
            <button type="button"
                    class="onboarding-filter-menu-item"
                    *ngFor="let opt of getPeriodMenuOptions(onboardingFilterOptions, onboardingIsCustom()); trackBy: trackPeriodOption"
                    role="option"
                    [attr.aria-selected]="isFilterOptionActive(opt.value, onboardingFilter, onboardingIsCustom())"
                    [class.onboarding-filter-menu-item--active]="isFilterOptionActive(opt.value, onboardingFilter, onboardingIsCustom())"
                    (click)="selectOnboardingFilter(opt.value)">
              <span>{{ opt.label }}</span>
              <i class="bi bi-check-lg onboarding-filter-menu-check" *ngIf="isFilterOptionActive(opt.value, onboardingFilter, onboardingIsCustom())"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="card-metrics">
        <div class="metric-main">
          <span class="metric-value">{{ onboardingTotal }}</span>
          <span class="metric-label">Total Onboarded</span>
        </div>
        <div class="onboarding-date-info" *ngIf="!isLoadingOnboarding && onboardingDateRange">
          <div class="onboarding-date-icon-wrap">
            <i class="bi bi-calendar3"></i>
          </div>
          <div class="onboarding-date-text">
            <span class="onboarding-date-period">Period</span>
            <div class="onboarding-date-range-row"
                 [class.onboarding-date-range-row--nav]="onboardingFilter !== 'all'">
              <button type="button" class="onboarding-week-nav-btn"
                      *ngIf="onboardingFilter !== 'all'"
                      (click)="onOnboardingWeekNav('prev')"
                      aria-label="Previous period">
                <i class="bi bi-chevron-left"></i>
              </button>
              <span class="onboarding-date-range">{{ onboardingDateRange }}</span>
              <button type="button" class="onboarding-week-nav-btn"
                      *ngIf="onboardingFilter !== 'all'"
                      [disabled]="isOnboardingNextDisabled()"
                      (click)="onOnboardingWeekNav('next')"
                      aria-label="Next period">
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="metric-trend" [ngClass]="getTrendClass(onboardingTrend)">
          <i class="bi {{ getTrendIcon(onboardingTrend) }}"></i>
          <span>{{ formatTrend(onboardingTrend) }}</span>
          <span class="metric-vs">vs prev 24h</span>
        </div>
      </div>

      <!-- Skeleton -->
      <div class="chart-skeleton" *ngIf="isLoadingOnboarding">
        <div class="sk-chart-bar" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]"
             [style.height.px]="30 + (i * 8)"></div>
      </div>

      <div class="chart-area" [style.display]="isLoadingOnboarding ? 'none' : 'block'">
        <canvas #onboardingCanvas></canvas>
      </div>

      <p class="chart-hint" *ngIf="!isLoadingOnboarding">
        <i class="bi bi-cursor-fill"></i>
        Click any point to view details
      </p>
    </div>

    <!-- ─── Card 2: Engagement Trend (moved here from Distribution Row) ─── -->
    <div class="analytics-card">
      <div class="card-header">
        <div class="card-title-group">
          <span class="card-badge card-badge--green">
            <i class="bi bi-activity"></i>
          </span>
          <span class="card-title">Engagement Trend</span>
        </div>
        <!--
          Yesterday/Last 7 Days dropdown (see .period-filter-select-* in CSS
          and toggleEngagementFilterMenu/selectEngagementFilter/
          getEngagementFilterLabel in the component). 'Today' is intentionally
          hidden for this card only, via engagementFilterOptions — every
          other dropdown-driven card is unaffected.
        -->
        <div class="period-filter-select-wrap"
             [class.period-filter-select-wrap--open]="engagementFilterMenuOpen"
             (click)="$event.stopPropagation()">
          <button type="button"
                  class="period-filter-select-btn"
                  (click)="toggleEngagementFilterMenu()"
                  [attr.aria-expanded]="engagementFilterMenuOpen"
                  aria-haspopup="listbox">
            <i class="bi bi-calendar-week period-filter-select-icon"></i>
            <span class="period-filter-select-label">{{ getEngagementFilterLabel() }}</span>
            <i class="bi bi-chevron-down period-filter-select-arrow"></i>
          </button>

          <div class="period-filter-menu" role="listbox" *ngIf="engagementFilterMenuOpen">
            <button type="button"
                    class="period-filter-menu-item"
                    *ngFor="let opt of getPeriodMenuOptions(engagementFilterOptions, engagementIsCustom()); trackBy: trackPeriodOption"
                    role="option"
                    [attr.aria-selected]="isFilterOptionActive(opt.value, engagementFilter, engagementIsCustom())"
                    [class.period-filter-menu-item--active]="isFilterOptionActive(opt.value, engagementFilter, engagementIsCustom())"
                    (click)="selectEngagementFilter(opt.value)">
              <span>{{ opt.label }}</span>
              <i class="bi bi-check-lg period-filter-menu-check" *ngIf="isFilterOptionActive(opt.value, engagementFilter, engagementIsCustom())"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Period Row (reusable — see .period-row-* in CSS) -->
      <div class="period-row" *ngIf="!isLoadingEngagement && engagementDateRange">
        <div class="period-row-icon-wrap">
          <i class="bi bi-calendar3"></i>
        </div>
        <div class="period-row-text">
          <span class="period-row-label">Period</span>
          <div class="period-row-range-wrap" [class.period-row-range-wrap--nav]="engagementFilter !== 'all'">
            <button type="button" class="period-nav-btn"
                    *ngIf="engagementFilter !== 'all'"
                    (click)="onEngagementWeekNav('prev')"
                    aria-label="Previous period">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="period-row-range">{{ engagementDateRange }}</span>
            <button type="button" class="period-nav-btn"
                    *ngIf="engagementFilter !== 'all'"
                    [disabled]="isEngagementNextDisabled()"
                    (click)="onEngagementWeekNav('next')"
                    aria-label="Next period">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Summary + Subtitle -->
      <ng-container *ngIf="!isLoadingEngagement && !engagementError">
        <div class="engagement-summary-row">
          <div class="engagement-summary-main">
            <span class="engagement-summary-label">Logged-in Users</span>
            <span class="engagement-summary-value">{{ engagementTotal | number }}</span>
          </div>
          <div class="engagement-summary-trend" [ngClass]="getTrendClass(engagementTrend)">
            <i class="bi {{ getTrendIcon(engagementTrend) }}"></i>
            <span>{{ formatTrend(engagementTrend) }}</span>
            <span class="engagement-summary-vs">{{ engagementVsLabel }} ({{ engagementPreviousTotal }})</span>
          </div>
        </div>
        <p class="card-subtitle engagement-subtitle">
          Distribution of logged-in users by time spent in the application
        </p>
      </ng-container>

      <!-- Summary Skeleton -->
      <div class="engagement-summary-row engagement-summary-row--skeleton" *ngIf="isLoadingEngagement">
        <div class="sk-text sk-text--lg"></div>
        <div class="sk-text sk-text--sm"></div>
      </div>

      <!-- Chart Skeleton -->
      <div class="chart-skeleton" *ngIf="isLoadingEngagement">
        <div class="sk-chart-bar" *ngFor="let i of [1,2,3,4,5,6,7]"
             [style.height.px]="25 + (i * 10)"></div>
      </div>

      <!-- Error State -->
      <div class="engagement-state-wrap" *ngIf="!isLoadingEngagement && engagementError">
        <i class="bi bi-exclamation-triangle engagement-state-icon engagement-state-icon--error"></i>
        <span class="engagement-state-text">Unable to load engagement trend</span>
        <button class="engagement-retry-btn" (click)="retryEngagementLoad()">
          <i class="bi bi-arrow-clockwise"></i> Retry
        </button>
      </div>

      <!-- Empty State -->
      <div class="engagement-state-wrap"
           *ngIf="!isLoadingEngagement && !engagementError && engagementDatasets.length === 0">
        <i class="bi bi-graph-up engagement-state-icon"></i>
        <span class="engagement-state-text">No engagement data available</span>
      </div>

      <!-- Chart -->
      <div class="chart-area"
           [style.display]="(!isLoadingEngagement && !engagementError && engagementDatasets.length > 0) ? 'block' : 'none'">
        <canvas #engagementCanvas></canvas>
      </div>

      <!-- Legend -->
      <div class="engagement-legend-row" *ngIf="!isLoadingEngagement && !engagementError && engagementDatasets.length > 0">
        <span class="engagement-legend-item">
          <span class="engagement-legend-dot engagement-legend-dot--blue"></span> &lt;30 mins
        </span>
        <span class="engagement-legend-item">
          <span class="engagement-legend-dot engagement-legend-dot--orange"></span> 30–90 mins
        </span>
        <span class="engagement-legend-item">
          <span class="engagement-legend-dot engagement-legend-dot--green"></span> &gt;90 mins
        </span>
      </div>

      <p class="chart-hint" *ngIf="!isLoadingEngagement && !engagementError && engagementDatasets.length > 0">
        <i class="bi bi-cursor-fill"></i>
        Click any point to view details
      </p>
    </div>
    <!-- ─── END Engagement Card ─── -->

    <!-- ─── Card 3: Mobile App Usage (existing position, unchanged internals) ─── -->
    <div class="analytics-card">
      <div class="card-header">
        <div class="card-title-group">
          <span class="card-badge card-badge--teal">
            <i class="bi bi-phone-fill"></i>
          </span>
          <div>
            <div class="card-title">Mobile App Downloads</div>
            <!-- <div class="card-subtitle">Downloaded users trend across platforms</div> -->
          </div>
        </div>
        <!-- Shared Today/Yesterday/Last 7 Days dropdown (see Engagement Trend card above for structure notes) -->
        <div class="period-filter-select-wrap"
             [class.period-filter-select-wrap--open]="mobileFilterMenuOpen"
             (click)="$event.stopPropagation()">
          <button type="button"
                  class="period-filter-select-btn"
                  (click)="toggleMobileFilterMenu()"
                  [attr.aria-expanded]="mobileFilterMenuOpen"
                  aria-haspopup="listbox">
            <i class="bi bi-calendar-week period-filter-select-icon"></i>
            <span class="period-filter-select-label">{{ getMobileFilterLabel() }}</span>
            <i class="bi bi-chevron-down period-filter-select-arrow"></i>
          </button>

          <div class="period-filter-menu" role="listbox" *ngIf="mobileFilterMenuOpen">
            <button type="button"
                    class="period-filter-menu-item"
                    *ngFor="let opt of getPeriodMenuOptions(mobileFilterOptions, mobileIsCustom()); trackBy: trackPeriodOption"
                    role="option"
                    [attr.aria-selected]="isFilterOptionActive(opt.value, mobileFilter, mobileIsCustom())"
                    [class.period-filter-menu-item--active]="isFilterOptionActive(opt.value, mobileFilter, mobileIsCustom())"
                    (click)="selectMobileFilter(opt.value)">
              <span>{{ opt.label }}</span>
              <i class="bi bi-check-lg period-filter-menu-check" *ngIf="isFilterOptionActive(opt.value, mobileFilter, mobileIsCustom())"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Period Row (reusable — see .period-row-* in CSS) -->
      <div class="period-row" *ngIf="!isLoadingMobile && mobileDateRange">
        <div class="period-row-icon-wrap">
          <i class="bi bi-calendar3"></i>
        </div>
        <div class="period-row-text">
          <span class="period-row-label">Period</span>
          <div class="period-row-range-wrap" [class.period-row-range-wrap--nav]="mobileFilter !== 'all'">
            <button type="button" class="period-nav-btn"
                    *ngIf="mobileFilter !== 'all'"
                    (click)="onMobileWeekNav('prev')"
                    aria-label="Previous period">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="period-row-range">{{ mobileDateRange }}</span>
            <button type="button" class="period-nav-btn"
                    *ngIf="mobileFilter !== 'all'"
                    [disabled]="isMobileNextDisabled()"
                    (click)="onMobileWeekNav('next')"
                    aria-label="Next period">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- KPI Row -->
      <div class="mobile-kpi-row" *ngIf="!isLoadingMobile">
        <div class="mobile-kpi" (click)="navigateToMobileUsers('android')" title="View Android users">
          <div class="mobile-kpi-icon mobile-kpi-icon--android">
            <i class="bi bi-android2"></i>
          </div>
          <div class="mobile-kpi-body">
            <span class="mobile-kpi-platform">Android</span>
            <div class="mobile-kpi-value-row">
              <span class="mobile-kpi-value">{{ mobileAndroidTotal | number }}</span>
              <span class="mobile-kpi-trend" [ngClass]="mobileAndroidTrend >= 0 ? 'trend-up' : 'trend-down'">
                <i class="bi {{ getTrendIcon(mobileAndroidTrend) }}"></i>
                {{ formatTrend(mobileAndroidTrend) }}
              </span>
            </div>
          </div>
        </div>
        <div class="mobile-kpi-divider"></div>
        <div class="mobile-kpi" (click)="navigateToMobileUsers('ios')" title="View iOS users">
          <div class="mobile-kpi-icon mobile-kpi-icon--ios">
            <i class="bi bi-apple"></i>
          </div>
          <div class="mobile-kpi-body">
            <span class="mobile-kpi-platform">iOS</span>
            <div class="mobile-kpi-value-row">
              <span class="mobile-kpi-value">{{ mobileIosTotal | number }}</span>
              <span class="mobile-kpi-trend" [ngClass]="mobileIosTrend >= 0 ? 'trend-up' : 'trend-down'">
                <i class="bi {{ getTrendIcon(mobileIosTrend) }}"></i>
                {{ formatTrend(mobileIosTrend) }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Skeleton -->
      <div class="chart-skeleton" *ngIf="isLoadingMobile">
        <div class="sk-chart-bar" *ngFor="let i of [1,2,3,4,5,6,7]"
             [style.height.px]="30 + (i * 18)"></div>
      </div>

      <div class="chart-area" [style.display]="isLoadingMobile ? 'none' : 'block'">
        <canvas #mobileCanvas></canvas>
      </div>

      <!-- Legend — below chart -->
      <div class="mobile-legend" *ngIf="!isLoadingMobile">
        <span class="mobile-legend-item">
          <span class="mobile-legend-dot mobile-legend-dot--android"></span> Android
        </span>
        <span class="mobile-legend-item">
          <span class="mobile-legend-dot mobile-legend-dot--ios"></span> iOS
        </span>
      </div>

      <p class="chart-hint">
        <i class="bi bi-cursor-fill"></i>
        Click any metric or bar to view detailed report
      </p>
    </div>

  </div>
  <!-- ══════════════ END ANALYTICS CARDS ══════════════ -->

  <!-- ══════════════ DISTRIBUTION ROW ══════════════ -->
  <div class="distribution-row">

    <!-- ─── Card 1: Profile Completion (moved here from Analytics Row) ─── -->
    <div class="analytics-card distribution-profile-card">
      <div class="card-header">
        <div class="card-title-group">
          <span class="card-badge card-badge--purple">
            <i class="bi bi-pie-chart-fill"></i>
          </span>
          <span class="card-title">Profile Completion</span>
        </div>
        <div class="card-total-badge">
          <span>{{ profileTotal }} users</span>
        </div>
      </div>

      <!-- Skeleton -->
      <div class="profile-skeleton" *ngIf="isLoadingProfile">
        <div class="sk-donut"></div>
        <div class="sk-legend">
          <div class="sk-legend-row" *ngFor="let i of [1,2,3,4,5]"></div>
        </div>
      </div>

      <div class="profile-chart-layout" *ngIf="!isLoadingProfile">
        <div class="donut-wrap">
          <canvas #donutCanvas></canvas>
          <div class="donut-center">
            <span class="donut-total">{{ profileTotal }}</span>
            <span class="donut-label">Users</span>
          </div>
        </div>

        <div class="donut-legend">
          <div class="legend-item"
               *ngFor="let range of profileRanges; let i = index"
               (click)="navigateToLawyers(range)"
               [class.legend-item--active]="activeSegmentIndex === i"
               title="View {{ range.label }} lawyers">
            <span class="legend-dot" [style.background]="range.color"></span>
            <span class="legend-range">{{ range.label }}</span>
            <span class="legend-count">{{ range.count }}</span>
            <span class="legend-pct">({{ getSegmentPercent(range.count) }}%)</span>
            <i class="bi bi-arrow-right legend-arrow"></i>
          </div>
        </div>
      </div>

      <p class="chart-hint" *ngIf="!isLoadingProfile">
        <i class="bi bi-cursor-fill"></i>
        Click any segment or row to view filtered lawyers
      </p>
    </div>
    <!-- ─── END Profile Completion Card ─── -->

    <!-- ─── Card 2: Lawyer Distribution by Location ─── -->
    <div class="analytics-card distribution-location-card">
      <div class="card-header">
        <div class="card-title-group">
          <span class="card-badge card-badge--orange">
            <i class="bi bi-geo-alt-fill"></i>
          </span>
          <span class="card-title">Lawyer Distribution by Location</span>
        </div>
        <!-- Shared Today/Yesterday/Last 7 Days dropdown (see Engagement Trend card notes) -->
        <div class="period-filter-select-wrap"
             [class.period-filter-select-wrap--open]="locationFilterMenuOpen"
             (click)="$event.stopPropagation()">
          <button type="button"
                  class="period-filter-select-btn"
                  (click)="toggleLocationFilterMenu()"
                  [attr.aria-expanded]="locationFilterMenuOpen"
                  aria-haspopup="listbox">
            <i class="bi bi-calendar-week period-filter-select-icon"></i>
            <span class="period-filter-select-label">{{ getLocationFilterLabel() }}</span>
            <i class="bi bi-chevron-down period-filter-select-arrow"></i>
          </button>

          <div class="period-filter-menu" role="listbox" *ngIf="locationFilterMenuOpen">
            <button type="button"
                    class="period-filter-menu-item"
                    *ngFor="let opt of getPeriodMenuOptions(locationPracticeFilterOptions, locationIsCustom()); trackBy: trackPeriodOption"
                    role="option"
                    [attr.aria-selected]="isFilterOptionActive(opt.value, locationFilter, locationIsCustom())"
                    [class.period-filter-menu-item--active]="isFilterOptionActive(opt.value, locationFilter, locationIsCustom())"
                    (click)="selectLocationFilter(opt.value)">
              <span>{{ opt.label }}</span>
              <i class="bi bi-check-lg period-filter-menu-check" *ngIf="isFilterOptionActive(opt.value, locationFilter, locationIsCustom())"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Period Row (reusable — see .period-row-* in CSS). Hidden entirely for 'All Time' (no row, no "Entire Dataset" text, no nav arrows). -->
      <div class="period-row" *ngIf="!isLoadingLocation && locationDateRange && locationFilter !== 'all'">
        <div class="period-row-icon-wrap">
          <i class="bi bi-calendar3"></i>
        </div>
        <div class="period-row-text">
          <span class="period-row-label">Period</span>
          <div class="period-row-range-wrap period-row-range-wrap--nav">
            <button type="button" class="period-nav-btn"
                    (click)="onLocationWeekNav('prev')"
                    aria-label="Previous period">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="period-row-range">{{ locationDateRange }}</span>
            <button type="button" class="period-nav-btn"
                    [disabled]="isLocationNextDisabled()"
                    (click)="onLocationWeekNav('next')"
                    aria-label="Next period">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Location KPI Row -->
      <div class="location-kpi-row" *ngIf="!isLoadingLocation">
        <div class="location-kpi">
          <span class="location-kpi-label">Total Cities</span>
          <span class="location-kpi-value">{{ locationTotalCities }}</span>
        </div>
        <div class="location-kpi-divider"></div>
        <div class="location-kpi">
          <span class="location-kpi-label">Total Lawyers</span>
          <span class="location-kpi-value">{{ locationTotalLawyers | number }}</span>
        </div>
        <div class="location-kpi-divider"></div>
        <div class="location-kpi">
          <span class="location-kpi-label">Most Lawyers From</span>
          <span class="location-kpi-value location-kpi-value--highlight">{{ locationTopCity }}</span>
        </div>
      </div>

      <!-- Location KPI Skeleton -->
      <div class="location-kpi-row" *ngIf="isLoadingLocation">
        <div class="location-kpi" *ngFor="let i of [1,2,3]">
          <div class="sk-text sk-text--lg"></div>
          <div class="sk-text sk-text--sm"></div>
        </div>
      </div>

      <!-- Top Locations -->
      <div class="location-list-section" *ngIf="!isLoadingLocation">
        <div class="location-list-title">Top Locations</div>
        <div class="location-table-scroll">
          <table class="location-table">
            <thead>
              <tr>
                <th class="loc-col-num">#</th>
                <th class="loc-col-name">City</th>
                <th class="loc-col-bar">Distribution</th>
                <th class="loc-col-count">Lawyers</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let city of locationTopCities; let i = index"
                  class="location-table-row"
                  (click)="navigateToLocationCity(city)"
                  title="View lawyers in {{ city.city }}">
                <td class="loc-col-num">{{ i + 1 }}</td>
                <td class="loc-col-name">{{ city.city }}</td>
                <td class="loc-col-bar">
                  <div class="location-bar-wrap">
                    <div class="location-bar"
                         [style.width.%]="getLocationBarWidth(city.count)">
                    </div>
                  </div>
                </td>
                <td class="loc-col-count">{{ city.count | number }}</td>
              </tr>
              <tr *ngIf="locationTopCities.length === 0">
                <td colspan="4" class="location-empty-cell">
                  <div class="location-empty">
                    <i class="bi bi-geo-alt"></i>
                    <span>No distribution data available.</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Location List Skeleton -->
      <div class="location-list-section" *ngIf="isLoadingLocation">
        <div class="sk-text sk-text--title"></div>
        <div class="location-list">
          <div class="location-row sk-row" *ngFor="let i of [1,2,3,4,5]">
            <div class="sk-text sk-text--full"></div>
          </div>
        </div>
      </div>

      <p class="chart-hint" *ngIf="!isLoadingLocation">
        <i class="bi bi-cursor-fill"></i>
        Click any segment or row to view filtered lawyers
      </p>
    </div>

    <!-- ─── Card 2: Practice Areas & Services Distribution ─── -->
    <div class="analytics-card distribution-practice-card">
      <div class="card-header">
        <div class="card-title-group">
          <span class="card-badge card-badge--indigo">
            <i class="bi bi-briefcase-fill"></i>
          </span>
          <span class="card-title">Practice Areas &amp; Services Distribution</span>
        </div>
        <!-- Shared Today/Yesterday/Last 7 Days dropdown (see Engagement Trend card notes) -->
        <div class="period-filter-select-wrap"
             [class.period-filter-select-wrap--open]="practiceFilterMenuOpen"
             (click)="$event.stopPropagation()">
          <button type="button"
                  class="period-filter-select-btn"
                  (click)="togglePracticeFilterMenu()"
                  [attr.aria-expanded]="practiceFilterMenuOpen"
                  aria-haspopup="listbox">
            <i class="bi bi-calendar-week period-filter-select-icon"></i>
            <span class="period-filter-select-label">{{ getPracticeFilterLabel() }}</span>
            <i class="bi bi-chevron-down period-filter-select-arrow"></i>
          </button>

          <div class="period-filter-menu" role="listbox" *ngIf="practiceFilterMenuOpen">
            <button type="button"
                    class="period-filter-menu-item"
                    *ngFor="let opt of getPeriodMenuOptions(locationPracticeFilterOptions, practiceIsCustom()); trackBy: trackPeriodOption"
                    role="option"
                    [attr.aria-selected]="isFilterOptionActive(opt.value, practiceFilter, practiceIsCustom())"
                    [class.period-filter-menu-item--active]="isFilterOptionActive(opt.value, practiceFilter, practiceIsCustom())"
                    (click)="selectPracticeFilter(opt.value)">
              <span>{{ opt.label }}</span>
              <i class="bi bi-check-lg period-filter-menu-check" *ngIf="isFilterOptionActive(opt.value, practiceFilter, practiceIsCustom())"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Period Row (reusable — see .period-row-* in CSS). Hidden entirely for 'All Time' (no row, no "Entire Dataset" text, no nav arrows). -->
      <div class="period-row" *ngIf="!isLoadingPractice && practiceDateRange && practiceFilter !== 'all'">
        <div class="period-row-icon-wrap">
          <i class="bi bi-calendar3"></i>
        </div>
        <div class="period-row-text">
          <span class="period-row-label">Period</span>
          <div class="period-row-range-wrap period-row-range-wrap--nav">
            <button type="button" class="period-nav-btn"
                    (click)="onPracticeWeekNav('prev')"
                    aria-label="Previous period">
              <i class="bi bi-chevron-left"></i>
            </button>
            <span class="period-row-range">{{ practiceDateRange }}</span>
            <button type="button" class="period-nav-btn"
                    [disabled]="isPracticeNextDisabled()"
                    (click)="onPracticeWeekNav('next')"
                    aria-label="Next period">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="practice-tabs">
        <button class="practice-tab"
                [class.practice-tab--active]="practiceActiveTab === 'practice'"
                (click)="onPracticeTabChange('practice')">
          Practice Areas
        </button>
        <button class="practice-tab"
                [class.practice-tab--active]="practiceActiveTab === 'services'"
                (click)="onPracticeTabChange('services')">
          Services Offered
        </button>
      </div>

      <!-- Filters Row -->
      <div class="practice-filters" *ngIf="!isLoadingPractice">
        <div class="practice-city-select">
          <label class="practice-filter-label">Select City</label>
          <div class="practice-select-wrap">
            <i class="bi bi-geo-alt-fill practice-select-icon"></i>
            <select class="practice-city-dropdown"
                    [(ngModel)]="practiceSelectedCity"
                    (ngModelChange)="onPracticeCityChange($event)">
              <option value="">All Cities</option>
              <option *ngFor="let city of practiceCityOptions" [value]="city">{{ city }}</option>
            </select>
            <i class="bi bi-chevron-down practice-select-arrow"></i>
          </div>
        </div>
        <div class="practice-search-wrap">
          <i class="bi bi-search practice-search-icon"></i>
          <input class="practice-search-input"
                 type="text"
                 [placeholder]="practiceActiveTab === 'practice' ? 'Search by practice area or keyword...' : 'Search by service or keyword...'"
                 [(ngModel)]="practiceSearchQuery"
                 (ngModelChange)="onPracticeSearchChange($event)" />
          <i class="bi bi-x-circle practice-search-clear"
             *ngIf="practiceSearchQuery"
             (click)="clearPracticeSearch()"></i>
        </div>
      </div>

      <!-- Dynamic Stats -->
      <div class="practice-stats-row" *ngIf="!isLoadingPractice">
        <div class="practice-stat">
          <span class="practice-stat-label">Selected City</span>
          <span class="practice-stat-value">{{ practiceSelectedCity || 'All Cities' }}</span>
        </div>
        <div class="practice-stat-divider"></div>
        <div class="practice-stat">
          <span class="practice-stat-label">Total Lawyers</span>
          <span class="practice-stat-value">{{ practiceTotalLawyers | number }}</span>
        </div>
        <div class="practice-stat-divider"></div>

        <!-- Practice Areas tab stats -->
        <ng-container *ngIf="practiceActiveTab === 'practice'">
          <div class="practice-stat">
            <span class="practice-stat-label">Total Practice Areas</span>
            <span class="practice-stat-value">{{ practiceTotalAreas }}</span>
          </div>
          <div class="practice-stat-divider"></div>
          <div class="practice-stat practice-stat--highlight">
            <span class="practice-stat-label">Most Lawyers from Practice Area</span>
            <span class="practice-stat-value practice-stat-value--highlight">
              {{ practiceTopAreaName }}<br>
              <small>{{ practiceTopAreaCount }} Lawyers ({{ practiceTopAreaPct }}%)</small>
            </span>
          </div>
        </ng-container>

        <!-- Services tab stats -->
        <ng-container *ngIf="practiceActiveTab === 'services'">
          <div class="practice-stat">
            <span class="practice-stat-label">Total Services Offered</span>
            <span class="practice-stat-value">{{ practiceTotalServices }}</span>
          </div>
          <div class="practice-stat-divider"></div>
          <div class="practice-stat practice-stat--highlight">
            <span class="practice-stat-label">Top Service Offered</span>
            <span class="practice-stat-value practice-stat-value--highlight">
              {{ practiceTopServiceName }}<br>
              <small>{{ practiceTopServiceCount }} Lawyers ({{ practiceTopServicePct }}%)</small>
            </span>
          </div>
        </ng-container>
      </div>

      <!-- Stats Skeleton -->
      <div class="practice-stats-row practice-stats-row--skeleton" *ngIf="isLoadingPractice">
        <div class="practice-stat" *ngFor="let i of [1,2,3,4]">
          <div class="sk-text sk-text--sm"></div>
          <div class="sk-text sk-text--lg"></div>
        </div>
      </div>

      <!-- Distribution Table -->
      <div class="practice-table-wrap">

        <!-- Table Skeleton -->
        <div class="practice-table-skeleton" *ngIf="isLoadingPractice">
          <div class="sk-table-row" *ngFor="let i of [1,2,3,4,5,6]">
            <div class="sk-text sk-text--full"></div>
          </div>
        </div>

        <div class="practice-table-container" *ngIf="!isLoadingPractice">
          <div class="practice-table-title" *ngIf="practiceActiveTab === 'practice'">
            Practice Areas in {{ practiceSelectedCity || 'All Cities' }}
          </div>
          <div class="practice-table-title" *ngIf="practiceActiveTab === 'services'">
            Services Offered in {{ practiceSelectedCity || 'All Cities' }}
          </div>

          <!-- Table -->
          <div class="practice-table-scroll">
            <table class="practice-table">
              <thead>
                <tr>
                  <th class="col-num">#</th>
                  <th class="col-name">{{ practiceActiveTab === 'practice' ? 'Practice Area' : 'Service Offered' }}</th>
                  <th class="col-bar">Distribution</th>
                  <th class="col-count">Lawyers</th>
                  <th class="col-pct">% of Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of practiceFilteredList; let i = index"
                    class="practice-table-row"
                    (click)="navigateToPracticeItem(item)"
                    title="View lawyers for {{ item.name }}">
                  <td class="col-num">{{ i + 1 }}</td>
                  <td class="col-name">{{ item.name }}</td>
                  <td class="col-bar">
                    <div class="practice-bar-wrap">
                      <div class="practice-bar"
                           [class.practice-bar--purple]="practiceActiveTab === 'services'"
                           [style.width.%]="getPracticeBarWidth(item.count)">
                      </div>
                    </div>
                  </td>
                  <td class="col-count">{{ item.count }}</td>
                  <td class="col-pct">({{ getPracticeItemPct(item.count) }}%)</td>
                </tr>
                <tr *ngIf="practiceFilteredList.length === 0">
                  <td colspan="5" class="practice-empty-cell">
                    <div class="practice-empty">
                      <i class="bi bi-inbox"></i>
                      <span>No distribution data available.</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <p class="chart-hint" *ngIf="!isLoadingPractice">
        <i class="bi bi-cursor-fill"></i>
        Click any segment or row to view filtered lawyers
      </p>
    </div>
    <!-- ─── END Practice Card ─── -->

  </div>
  <!-- ══════════════ END DISTRIBUTION ROW ══════════════ -->

</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff"
             type="ball-clip-rotate" [fullScreen]="true">
</ngx-spinner>